import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${(p) => p.theme.font.small};
  margin-bottom: ${(p) => p.theme.spacing.xLarge};
  z-index: 1;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: ${(p) => p.theme.spacing.large};
  }
`;

export const WrapperRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${(p) => p.theme.spacing.medium};

  label {
    padding: 0;
    width: 155px;
  }

  input {
    color: ${(p) => p.theme.colors.textSecondary};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: ${(p) => p.theme.spacing.medium};
  }
`;

export const WrapperLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.quark};
`;

export const SupplementaryTitle = styled.span`
  font-weight: 300;
`;

export const Title = styled.h1`
  color: ${(p) => p.theme.colors.primary};
  font-size: ${(p) => p.theme.font.xxLarge};
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: ${(p) => p.theme.font.xLarge};
  }
`;

export const Subtitle = styled.div`
  font-weight: 300;
  white-space: nowrap;

  strong {
    color: ${(p) => p.theme.colors.primary};
  }
`;
